module.exports = __webpack_public_path__ + "img/注册流程@2x.2b1cbfbb.png";